export default "__VITE_ASSET__85f7a518__"